import 'react-datepicker/dist/react-datepicker.css';
import './Hallie.scss';

import { Button, Form, Spinner } from 'react-bootstrap';
import React, { useEffect, useRef, useState } from 'react';

import CompanyAPI from '../company/CompanyAPI';
import FloatingVideoButton from '../../commons/buttons/FloatingVideoButton';
import HallieAPI from './HallieAPI';

const hallieAPI = new HallieAPI();
const companyAPI = new CompanyAPI();

function Hallie() {
  const [input, setInput] = useState('');
  const [chat, setChat] = useState([
    { role: 'hallie', content: 'Olá! Eu sou a Hallie 💡\nPosso te ajudar com ideias de campanhas, posts ou promoções!' },
  ]);
  const [loading, setLoading] = useState(false);
  const chatRef = useRef(null);
  const endRef = useRef(null);

  const scrollToBottom = () => {
    endRef.current?.scrollIntoView({ behavior: 'smooth', block: 'end' });
  };

  useEffect(() => {
    scrollToBottom();
  }, [chat, loading]);

  const responderHallie = async (pergunta) => {
    setLoading(true);

    const data = {
      question: pergunta,
      companyId: companyAPI.getCompanyManagment()?.id,
    };

    try {
      const resp = await hallieAPI.sendMessage(data);
      const content = resp?.data?.choices?.[0]?.message?.content?.trim();

      setChat((prev) => [
        ...prev,
        { role: 'hallie', content: content || 'Tenho uma ideia! Que tal começarmos por uma campanha de fidelidade? 😄' },
      ]);
    } catch (err) {
      console.error('Erro ao consultar Hallie:', err);
      setChat((prev) => [
        ...prev,
        {
          role: 'hallie',
          content:
            'Desculpe, não consegui responder agora 😓\nTente novamente em alguns instantes ou reformule sua pergunta.',
        },
      ]);
    } finally {
      setLoading(false);
    }
  };

  const handleSend = () => {
    const text = input.trim();
    if (!text || loading) return;

    const userMsg = { role: 'user', content: text };
    setChat((prev) => [...prev, userMsg]);
    setInput('');
    responderHallie(text);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  const handleQuickQuestion = (text) => {
    if (loading) return;
    setChat((prev) => [...prev, { role: 'user', content: text }]);
    responderHallie(text);
  };

  return (
    <div className="hallie">
      <div className="hallie__container">
        {/* Header */}
        <div className="hallie__header">💬 Hallie - Consultora Virtual</div>

        {/* Perguntas rápidas */}
        <div className="hallie__quick">
          <div className="d-flex flex-wrap gap-2">
            <Button
              variant="outline-secondary"
              size="sm"
              onClick={() => handleQuickQuestion('Como posso aumentar o faturamento esse mês?')}
              disabled={loading}
            >
              💸 Aumentar faturamento
            </Button>
            <Button
              variant="outline-secondary"
              size="sm"
              onClick={() => handleQuickQuestion('Quais clientes estão inativos?')}
              disabled={loading}
            >
              💤 Clientes inativos
            </Button>
            <Button
              variant="outline-secondary"
              size="sm"
              onClick={() => handleQuickQuestion('Sugira uma campanha para este mês')}
              disabled={loading}
            >
              🎯 Campanha do mês
            </Button>
            <Button
              variant="outline-secondary"
              size="sm"
              onClick={() => handleQuickQuestion('Qual serviço mais vendido e como explorar isso?')}
              disabled={loading}
            >
              📊 Serviço mais vendido
            </Button>
          </div>
        </div>

        {/* Chat body */}
        <div ref={chatRef} className="hallie__chat">
          {chat.map((msg, idx) => (
            <div
              key={idx}
              className={`hallie__row ${msg.role === 'user' ? 'is-user' : 'is-hallie'}`}
            >
              <div className={`hallie__bubble ${msg.role === 'user' ? 'bubble-user' : 'bubble-hallie'}`}>
                {msg.content}
              </div>
            </div>
          ))}

          {loading && (
            <div className="hallie__thinking">
              <Spinner animation="border" size="sm" className="me-2" />
              Hallie está pensando...
            </div>
          )}
          <div ref={endRef} />
        </div>

        {/* Input */}
        <div className="hallie__input">
          <Form className="d-flex align-items-end gap-2">
            <Form.Control
              as="textarea"
              rows={1}
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={handleKeyPress}
              placeholder="Escreva sua ideia ou dúvida... (Enter envia, Shift+Enter quebra linha)"
              className="hallie__textarea"
            />
            <Button
              className="hallie__send"
              onClick={handleSend}
              disabled={loading || !input.trim()}
              variant="dark"
              title="Enviar (Enter)"
              aria-label="Enviar mensagem"
            >
              ➤
            </Button>
          </Form>
        </div>
        <div style={{ height: "calc(50px + 72px)" }}></div>
      </div>

      <FloatingVideoButton youtubeUrl={"https://www.youtube.com/embed/mWA1aUwQ47A"} />

    </div>
  );
}

export default Hallie;